module.exports = __webpack_public_path__ + "static/media/J (2).b570bd59.jpg";